module.exports = __webpack_public_path__ + "img/project2.1d9eabe2.jpeg";